import {NestFactory} from '@nestjs/core';
import {ConfigService} from '@nestjs/config';
import {FastifyAdapter, NestFastifyApplication} from '@nestjs/platform-fastify';
import {AppModule} from './app.module';
import * as dotenv from 'dotenv';

dotenv.config(); // 这会默认寻找当前工作目录下的 .env 文件

/**
 * 应用程序启动引导函数
 * 初始化高性能 Fastify 适配器与 CORS 跨域策略
 */
async function bootstrap() {
  const app = await NestFactory.create<NestFastifyApplication>(
    AppModule,
    new FastifyAdapter({logger: true}),
  );
  const configService = app.get(ConfigService);

  // 开启跨域支持，确保 Chrome 插件、VS Code 插件及 CLI 能够顺利调用
  app.enableCors();

  // 优先从环境变量获取端口，其次从配置文件获取，最后回退到 3000
  const port = configService.get<number>('port') || 3000;
  await app.listen(port, '0.0.0.0');

  console.log(`🚀 Coda Agent Server is running on: http://localhost:${port}`);
}
bootstrap();
